// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__yRkWC","inner":"styles_inner__5yrtW","balanceOpened":"styles_balanceOpened__J5lkT","icon":"styles_icon__78cZK","text":"styles_text__9OVK5"};